// extracted by mini-css-extract-plugin
export var legendIndicator = "_ei-1";
export var legendRight = "_ei-0";